/** @jsxImportSource @emotion/react */

import { Pages } from 'modules/navigation/domain/enums/pages';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIsAdmin } from 'shared/hooks/use-is-admin';

import { AppDispatch } from 'store/store';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import NotFound from 'ud-ui/components/images/not-found.png';
import UDText from 'ud-ui/components/text';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { fetchBoardsByTemplateId, fetchCatalogTemplates } from '../../store/templates/actions';
import { selectCatalogTemplatesByFilter } from '../../store/templates/selectors';
import Header from '../components/catalog/header';
import NewTemplate from '../components/catalog/new-template';
import TemplateItem from '../components/catalog/template-item';
import { TemplateListCatalog } from './styles';

function Catalog() {
  const { setHeaderContent } = useMainLayout();
  const breadcrumb = useMemo(
    () => (
      <UDBreadcrumbs
        className="my-10"
        breadcrumbs={[
          { label: 'Турниры', to: Pages.TOURNEYS.INDEX },
          { label: 'Шаблоны', to: Pages.TEMPLATE.INDEX },
          { label: 'Готовые шаблоны', to: Pages.TEMPLATE.CATALOG.INDEX },
        ]}
      />
    ),
    [],
  );

  const dispatch = useDispatch<AppDispatch>();
  const templates = useSelector(selectCatalogTemplatesByFilter);
  const { loadedTemplates } = useTemplates();

  const isAdmin = useIsAdmin();

  useEffect(() => {
    if (templates.length > 0) {
      return;
    }
    dispatch(fetchCatalogTemplates({ visibility: isAdmin ? ['superAdmin', 'all'] : ['all'] }));
  }, [dispatch, isAdmin, templates.length]);

  useEffect(() => {
    if (templates.length > 0) {
      const promises = templates
        .filter((template) => !loadedTemplates.includes(template.id))
        .map((template) => dispatch(fetchBoardsByTemplateId({ templateId: template.id })));
      Promise.all(promises);
    }
  }, [dispatch, loadedTemplates, templates, templates.length]);

  useEffect(() => {
    setHeaderContent(breadcrumb);
    return () => setHeaderContent(null);
  }, [breadcrumb, setHeaderContent]);

  return (
    <>
      <div className={'flex flex-col'} style={{ height: '100%', overflow: 'hidden' }}>
        <Header />
        {templates.length > 0 ? (
          <TemplateListCatalog>
            {templates.map((template) => (
              <TemplateItem key={template.id} template={template} />
            ))}
            {isAdmin && <NewTemplate />}
          </TemplateListCatalog>
        ) : (
          <div className={'flex-center flex h-full w-full flex-col'}>
            <img src={NotFound} alt={'empty'} style={{ height: 130, width: 130 }} />
            <UDText type={'callout'} style={{ color: '#8F8E99' }}>
              По такому запросу ничего не найдено
            </UDText>
          </div>
        )}
      </div>
    </>
  );
}

export default Catalog;
